import React, { Component } from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import classNames from 'classnames';
import { decorateIntlMessages } from './rosetta_formatted_message';
import { injectIntl, defineMessages } from 'react-intl';

const LoadableSwiper = loadable.lib(() => import(/* webpackChunkName: "swiper" */ 'react-id-swiper/lib/custom'));

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  previous_button_title: {
    id: 'previous_button_title',
    description: 'Previous button title attribute content (Previous)',
    defaultMessage: 'Previous'
  },
  next_button_title: {
    id: 'next_button_title',
    description: 'Next button title attribute content (Next)',
    defaultMessage: 'Next'
  }
}));

export class SwiperWrapper extends Component {

  constructor(props) {
    super(props);
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);

    this.state = {
      swiperIsBeginning: true,
      swiperIsEnd: false
    };
  }

  goNext() {
    if (this.swiper) {
      this.swiper.slideNext();
    }
  }

  goPrev() {
    if (this.swiper) {
      this.swiper.slidePrev();
    }
  }

  handleSlideChange = () => this.setState({
    swiperIsBeginning: this.swiper.isBeginning,
    swiperIsEnd: this.swiper.isEnd
  });

  render() {
    const sliderProps = {
      ...this.props.sliderProps,
      on: {
        ...this.props.sliderProps.on,
        slideChange: this.handleSlideChange
      }
    };

    return (
      <div className="flex-swiper-wrapper" tabIndex="0">
        <div
          className={classNames('swiper-button-prev', 'swiper-nav', { 'disabled': this.state.swiperIsBeginning })}
          onClick={this.goPrev}
          tabIndex="0"
          role="button"
          aria-label="previous items on slider"
          onKeyPress={this.goPrev}
          title={this.props.intl.formatMessage(i18nMessages.previous_button_title)}
        />
        <LoadableSwiper id="loadable-swiper">
          {({ default: Swiper }) => (
            <Swiper {...sliderProps} ref={node => this.swiper = node !== null ? node.swiper : null}>
              {this.props.children}
            </Swiper>
          )}
        </LoadableSwiper>
        <div
          className={classNames('swiper-button-next', 'swiper-nav', { 'disabled': this.state.swiperIsEnd })}
          onClick={this.goNext}
          onKeyPress={this.goNext}
          tabIndex="0"
          role="button"
          aria-label="more items on slider"
          title={this.props.intl.formatMessage(i18nMessages.next_button_title)}
        />
      </div>
    );
  }
}
export default injectIntl(SwiperWrapper);

SwiperWrapper.propTypes = {
  sliderProps: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  intl: PropTypes.object.isRequired
};
